export default __webpack_public_path__ + "static/media/postermodalimg.f9a5e764.jpg";